<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import OptionSelect from 'dashboard/components-next/select/OptionSelect.vue';
import { buildWorkflowEventSelectOptions } from './workflowEventTheme';

const props = defineProps({
  modelValue: { type: String, default: '' },
  events: { type: Array, required: true },
  hasError: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'change']);

const { t } = useI18n();

const options = computed(() => buildWorkflowEventSelectOptions(props.events));
</script>

<template>
  <OptionSelect
    :model-value="modelValue"
    :options="options"
    :has-error="hasError"
    :disabled="disabled"
    selected-icon-class="scale-[0.9]"
    :placeholder="t('AUTOMATION.FLOW.SELECT_TRIGGER')"
    :aria-label="t('AUTOMATION.ADD.FORM.EVENT.LABEL')"
    @update:model-value="value => emit('update:modelValue', value)"
    @change="() => emit('change')"
  />
</template>
